export class configPanel {

    index;
    service;
    preguntas = [];
    config;

    constructor(service, index) {
        this.service = service;
        this.index = index;
        this.preguntas = this.service.listRatinggs[this.index].rattings;
        this.reset(this.service.listRatinggs[this.index].config)
    }

    save() {
        
    }

    btn_editar() {
       
        
        this.dataView.edit = false;
    }

    btn_cancelar() {
        this.dataView.edit = true;
        this.reset();
        resetview();
        
    }

    createNewDate = () => {
        const currentDate = new Date();
        return {
            currentDate: currentDate,
            year: currentDate.getFullYear(),
            month: String(currentDate.getMonth() + 1).padStart(2, '0'),
            day: String(currentDate.getDate()).padStart(2, '0')
        }
    }

    reset(config) {     
        this.config = config
        this.dataView = {
            edit:false,
            date: this.config.date,
            name: this.config.name,
            edit: true,
            id:this.config.id,
            inputs: {
                name: {
                    value: this.config.name,
                    status: false,
                    valid: {
                        text: "",
                        style: "",
                        valid:true
                    },
                },
                modo: {
                    value: this.config.mode,
                    status: false,
                    valid: {
                        text: "",
                        style: "",
                        valid:true
                    },
                },
                autenticacion: {
                    value: this.config.login,
                    status: false,
                    valid: {
                        text: "",
                        style: "",
                        valid:true
                    },
                },
                opcpin: {
                    value: this.config.key[0],
                    status: false,
                    valid: {
                        text: "",
                        style: "",
                        valid:true
                    },
                },
                pin: {
                    value: this.config.key[1],
                    status: false,
                    valid: {
                        text: "",
                        style: "",
                        valid:true
                    },
                },
            },
        }
    }

    setData(data) {
        
        this.service.listRatinggs[this.index].config = {
            id:this.dataView.id,
            date: this.dataView.date,
                name: data.name.value,
                mode: data.modo.value,
                login:
                    data.autenticacion.value,
                key: [
                    data.opcpin.value,
                    data.pin.value,
                ]
            }
        this.reset(this.service.listRatinggs[this.index].config)

        return this.service;

    }

}